<template>
    <div class="study-room">
        <TopMenu></TopMenu>
        <div class="top">
            <!--<a href="javascript:history.go(-1);" class="back" v-if="isUa">
                <i class="el-icon-arrow-left"></i>
            </a>-->
            {{name}}
            <span  @click="gopage('/selectgrade');" class="right">
                选择年级
            </span>
        </div>
        <div class="s_banner">
            <img src="../../assets/images/mingshi_banner.jpg" alt=""/>
        </div>
        <Subject :list="list"></Subject>    
        <Loading :show="isUa && isLoading"></Loading>    
    </div>
</template>

<script>
import jsonp from 'jsonp';
import router from 'vue-router'
import Loading from "../loading"
import TopMenu from "../study/page/module/topmenu"
import Subject from "./subjectList"
export default{
    name: 'Weike',
    data(){
        return{
            name: "名师助学",
            isUa: window.navigator.userAgent.indexOf('ZgApp') < 0,
            isLoading: false,
            grade:this.getCookie("grade")||7, 
            list:[]
        }
    },
    created(){
        document.title = "名师助学";
        this.getData(13);
        this.getStatistPv();    
    },
    mounted(){
        /*if(window.location.href.indexOf('h5') > 0){
            window.location.href = 'http://byte.gxnews.com.cn/zg/#/study';    
        }*/
    },
    methods:{
        gopage(pagehash){
            this.$router.push({path:pagehash});  
        },
        getCookie(key){
            var arr = document.cookie.split('; ');
            for(var i = 0,len = arr.length;i < len;i ++){
                var list = arr[i].split('=');
                if(encodeURIComponent(key) === list[0]){
                    return decodeURIComponent(list[1]);
                }
            }
        },
        getData(){
            this.isLoading = true;
            console.log(this.grade);
            jsonp(`http://byte.gxnews.com.cn/php/qdapi.php?action=subjects&gradeId=${this.grade}`, {} , (err, data) => {
                this.isLoading = false;
                if (err) {
                    console.error(err.message);
                } else {
                    console.log(data);
                    this.list = data.data.map(item =>{
                    return {
                        name: item.name,
                        link: "#/weikeList/"+this.grade+"/"+item.id,
                        id: item.id

                    }
                    });
                    
                }
            })   
        },
        getStatistPv(){
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fweike&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })   
        }    
    },
    components: {
        Loading,
        TopMenu,
        Subject
    }
}
</script>

<style lang="less" scoped>
    .study-room{
        padding-top: 1rem;
        padding-bottom: 2rem;
        .s_banner{
            padding-top: 1rem;
            margin-top: 16px;
            img{
                width: 100%;
            }
        }
    }
    .top{
        position: fixed;
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        text-align: center;
        background: #fff;
        font-size: 0.43rem;
        font-weight: bold;
        color: #1960ab;
        left: 0;
        top:48px;
        border-bottom: 1px solid #f1f1f1;
        .back{
            position: absolute;
            top: 0;
            left: 0.3rem;
            font-size: 0.6rem;
            color: #333;
        }
        .right{
            position: absolute;
            top: 0;
            right: 0.3rem;
            font-size: 0.4rem;
            color: #333;
        }
    }        
</style>   